import type { Address } from "viem";
import { DEFAULT_WITHDRAW_SLIPPAGE } from "../constants";
import type { ChainId } from "./vault-config";
import { fetchWithdrawAssets } from "./withdraw-assets";

/**
 * Gets the slippage value for a specific asset in a vault
 * @param chainId The chain ID
 * @param vaultAddress The boring vault address
 * @param tokenAddress The token address
 * @param defaultSlippage Optional default slippage value if none is found (defaults to 0)
 * @returns Promise<number> The slippage value
 * @throws {AssetSlippageError} If there's an error fetching or processing the slippage data
 */
// TODO: This is a temporary function or should be moved and refactored to get the slippage value for a specific asset in a vault
export async function getAssetSlippage(
  chainId: ChainId,
  vaultAddress: Address,
  tokenAddress: Address,
  defaultSlippage: number = DEFAULT_WITHDRAW_SLIPPAGE
) {
  try {
    // Fetch withdraw assets data, using cache if available
    const withdrawAssets = await fetchWithdrawAssets();
    if (!withdrawAssets) {
      return defaultSlippage;
    }
    if (!withdrawAssets[chainId.toString()]) {
      return defaultSlippage;
    }
    if (!withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()]) {
      return defaultSlippage;
    }
    if (
      !withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()][
        tokenAddress.toLowerCase()
      ]
    ) {
      return defaultSlippage;
    }

    return withdrawAssets[chainId.toString()][vaultAddress.toLowerCase()][
      tokenAddress.toLowerCase()
    ];
  } catch (error) {
    // Log the error for debugging purposes
    console.error("Error fetching asset slippage:", error);
    throw new Error(
      `Error fetching asset slippage for chain ${chainId}: ${
        error instanceof Error ? error.message : String(error)
      }`
    );
  }
}
